import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./update-stockV.css";

const UpdateStock = ({ onUpdate }) => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedSubProduct, setSelectedSubProduct] = useState("");
  const [subProducts, setSubProducts] = useState([]);
  const [currentQuantity, setCurrentQuantity] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [modificationDate, setModificationDate] = useState(null);

  // Charger les produits et sous-produits
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("/api/ProductV/getProductV");
        const productList = Array.isArray(res.data) ? res.data : res.data?.data || [];
        setProducts(productList);
      } catch (err) {
        console.error("Erreur lors du chargement des produits :", err);
        setProducts([]);
      }
    };
    fetchProducts();
  }, []);

  // Mettre à jour la liste des sous-produits quand un produit est sélectionné
  useEffect(() => {
    if (!selectedProduct) return;
    const product = products.find(p => p._id === selectedProduct);
    setSubProducts(product?.subProductsV || []);
    setSelectedSubProduct(""); // réinitialiser le sous-produit
  }, [selectedProduct, products]);

  // Calculer le stock réel du produit/sous-produit
  useEffect(() => {
    const fetchStock = async () => {
      if (!selectedProduct) return;

      try {
        // Factures d'achat
        const invoiceResponse = await axios.get("/api/InvoiceV/getAllInvoices");
        let totalQuantity = 0;
        let totalCost = 0;

        invoiceResponse.data.forEach(inv => {
          inv.items.forEach(item => {
            // Vérifier si la ligne correspond au produit ou sous-produit sélectionné
            if ((selectedSubProduct && item.subProductV === selectedSubProduct) ||
                (!selectedSubProduct && item.productV === selectedProduct)) {
              totalQuantity += item.quantity || 0;
              totalCost += (item.quantity || 0) * (item.price || 0);
            }
          });
        });

        // Ici tu peux ajouter la soustraction des ventes si tu as une API de ventes
        // const salesResponse = await axios.get(`/api/Sales/getByProduct/${selectedSubProduct || selectedProduct}`);

        setCurrentQuantity(totalQuantity);
        setCurrentPrice(totalQuantity > 0 ? totalCost / totalQuantity : 0);
      } catch (err) {
        console.error("Erreur récupération stock réel :", err);
        setCurrentQuantity(0);
        setCurrentPrice(0);
      }
    };

    fetchStock();
  }, [selectedProduct, selectedSubProduct]);

  const handleUpdate = async () => {
    if (!selectedProduct) {
      alert("Veuillez sélectionner un produit ou sous-produit");
      return;
    }

    try {
      const updateDate = new Date();
      await axios.put("/api/Stock/update", {
        productV: selectedProduct,
        subProductV: selectedSubProduct || null,
        totalQuantity: currentQuantity,
        averagePrice: currentPrice
      });

      setModificationDate(updateDate);
      alert("Stock mis à jour !");
      onUpdate({ productV: selectedProduct, subProductV: selectedSubProduct, totalQuantity: currentQuantity, averagePrice: currentPrice });
    } catch (err) {
      console.error("Erreur mise à jour stock :", err);
      alert("Erreur lors de la mise à jour du stock");
    }
  };

  return (
    <div className="update-stock-container">
      <h2>Mise à jour du Stock</h2>

      <div className="form-group">
        <label>Produit</label>
        <select value={selectedProduct} onChange={e => setSelectedProduct(e.target.value)}>
          <option value="">-- Sélectionnez un produit --</option>
          {products.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
        </select>
      </div>

      <div className="form-group">
        <label>Sous-produit</label>
        <select
          value={selectedSubProduct}
          onChange={e => setSelectedSubProduct(e.target.value)}
          disabled={!selectedProduct || subProducts.length === 0}
        >
          <option value="">-- Aucun ou sélectionner un sous-produit --</option>
          {subProducts.map(sp => <option key={sp._id} value={sp._id}>{sp.name}</option>)}
        </select>
      </div>

      <div className="form-group">
        <label>Stock Réel</label>
        <input type="text" readOnly value={currentQuantity.toFixed(3)} />
      </div>

      <div className="form-group">
        <label>Prix Moyen Pondéré</label>
        <input type="text" readOnly value={currentPrice.toFixed(3) + " DT"} />
      </div>

      <div className="form-group">
        <label>Date de Modification</label>
        <input type="text" readOnly value={modificationDate ? modificationDate.toLocaleDateString() : new Date().toLocaleDateString()} />
      </div>

      <button onClick={handleUpdate}>Mettre à jour</button>
    </div>
  );
};

export default UpdateStock;
